package one.healthium.ricediet.di

import org.koin.dsl.module

internal actual fun composeAppPlatformModule() = module {
}